import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Review = {
  id: string;
  author_name: string;
  author_image: string | null;
  pet_name: string | null;
  city: string | null;
  rating: number;
  content: string;
  is_published: boolean;
  created_at: string;
};
